import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import CalendarIntegrationsTab from './integrations/CalendarIntegrationsTab.tsx';
import WebWidgetTab from './integrations/WebWidgetTab.tsx';
import AccountApiAccessTab from './integrations/AccountApiAccessTab.tsx';

export default function IntegrationsPage() {
  const [active, setActive] = useState('calendars');
  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <h1 className="text-2xl font-bold mb-6">Integrations</h1>
      <Tabs value={active} onValueChange={setActive} className="w-full">
        <TabsList className="grid w-full grid-cols-3 mb-6 max-w-md">
          <TabsTrigger value="calendars">Calendars</TabsTrigger>
          <TabsTrigger value="web">Web Widget</TabsTrigger>
          <TabsTrigger value="api">API & Zapier</TabsTrigger>
        </TabsList>
        <TabsContent value="calendars">
          <CalendarIntegrationsTab />
        </TabsContent>
        <TabsContent value="web">
          <WebWidgetTab />
        </TabsContent>
        <TabsContent value="api">
          <AccountApiAccessTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
